export class CompanyUserAssignedFacilityModel {
    public id: number;
    public name: string;
}
